import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';
import { EventInitVariables } from './event.interface';

export interface SmsModel extends BaseModel {
  variables?: { [key: string]: string } | SmsVariables;
}

export interface SmsVariables {
  Sms: string;
  SmsCtaLink: string
}

export class SmsInitVariables implements SmsVariables {
  Sms = '';
  SmsCtaLink= '';
}

export class SmsInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new SmsInitVariables();
    this.variables = {...initVars};
    this.notifications = [new NotificationInitVariables()];
  }
}
